import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Inventory/Inventory.css";
import { useParams } from "react-router-dom";

function Emailhandleinventory() {
  const [data, setData] = useState({
    enquirydetails: null,
    handelItems: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { enquiryId } = useParams();

  useEffect(() => {
    //const quoteId = localStorage.getItem("enquiry_id");

    if (enquiryId) {
      const fetchData = async () => {
        try {
          setLoading(true);
          const response = await axios.get(
            `https://www.skilledmovers.com.au/api/handel-estimate-quote/${enquiryId}`
          );

          // Set both enquirydetails and handelItems in a single state update
          setData({
            enquirydetails: response.data.enquirydetails,
            handelItems: response.data.handelItems,
          });
        } catch (error) {
          setError("Error fetching data");
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    } else {
      setError("No quote ID found in local storage");
      setLoading(false);
    }
  }, [enquiryId]); // Empty dependency array to run only once

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="inventory-container handle__invntory">
      <div className="">
        <div className="row py-2 ">
          <div className="col-4 col-md-6 mb-3 mb-md-0">
            <h2
              className="fs-5 heading__text__skilled"
              style={{ color: "#ff5c00" }}
            >
              Inventory List
            </h2>
          </div>
          <div className="col-4 col-md-3 text-center mb-3 mb-md-0">
            <h2
              className="fs-5 heading__text__skilled"
              style={{ color: "#ff5c00" }}
            >
              Quantity
            </h2>
          </div>
          <div className="col-4 col-md-3 text-end mb-3 mb-md-0">
            <h2
              className="fs-5 heading__text__skilled"
              style={{ color: "#ff5c00" }}
            >
              Volume
            </h2>
          </div>
        </div>
      </div>
      <hr />
      <div className="inventory-details">
        {data.handelItems.length > 0 && (
          <div className="">
            <ul className="list-unstyled">
              {data.handelItems.map((item) => (
                <li key={item.id} className="row py-2  align-items-center">
                  <div className="col-4 col-md-6">
                    <p className="mb-0">{item.item_name}</p>
                  </div>
                  <div className="col-4 col-md-3 text-center">
                    <p className="mb-0">{item.quantity}</p>
                  </div>
                  <div className="col-4 col-md-3 text-end">
                    <p className="mb-0">{item.volume}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Emailhandleinventory;
